import React from 'react';
import {CheckCircleIcon, InfoIcon, XIcon} from 'lucide-react';
import {Box, Typography} from '@mui/material';
import PropTypes from 'prop-types';

const chipStyles = {
  success: {
    color: '#162523',
    borderColor: '#74BC09',
    backgroundColor: '#EDFAD8',
    icon: {
      color: '#74BC09',
    },
  },
  ghost: {
    color: '#7E8986',
    borderColor: '#DCE2E0',
    backgroundColor: '#F2F5F4',
    icon: {
      color: '#7E8986',
    },
  },
  error: {
    color: '#162523',
    borderColor: '#DA3E30',
    backgroundColor: '#FFE5E2',
    icon: {
      color: '#DA3E30',
    },
  },
};

export const CountChip = ({variant, label, icon}) => {
  function getIcon() {
    const style = {color: chipStyles[variant].icon.color};

    if (icon === 'x') {
      return <XIcon size={16} style={style} />;
    } else if (icon === 'check') {
      return <CheckCircleIcon size={16} style={style} />;
    } else if (icon === 'info') {
      return <InfoIcon size={16} style={style} />;
    }

    return null;
  }

  return (
    <Box
      paddingX={1.5}
      py={0.75}
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius={5}
      border="1px solid transparent"
      sx={{...chipStyles[variant]}}
    >
      {getIcon()}
      <Typography
        color={{color: chipStyles[variant].color}}
        fontSize={14}
        fontWeight={600}
        pl={0.75}
      >
        {label}
      </Typography>
    </Box>
  );
};

CountChip.propTypes = {
  variant: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.string.isRequired,
};
